import type { Study } from '@pocketprep/types'
import { initLoadable } from '@/store/utils'
import type { Loadable } from '@/store/utils'

type TUserExamMetadataState = {
    userExamMetadata: Loadable<Study.Class.UserExamMetadataJSON[]>
    isTogglingFlag: boolean
    lastTimeTogglingFlag: number
}

export const getInitialUserExamMetadataState = (): TUserExamMetadataState => {
    return {
        userExamMetadata: initLoadable([]),
        isTogglingFlag: false,
        lastTimeTogglingFlag: 0,
    }
}

const moduleState = getInitialUserExamMetadataState()

export default moduleState
